import { CITIES, CONDICION, PROVINCIAS } from 'Constants'

export const FieldsDest = (data, handleChangeDest, edit) => {
  const provinciaId = PROVINCIAS.find(
    (p) => p.provincia.trim() === data.shipping?.destinatario?.provincia?.trim()
  )?.id
  const localidadesFiltradas = CITIES.filter((city) => city.provincia_id === provinciaId)
  const localidadSeleccionada = localidadesFiltradas.find(
    (city) => city.localidad === data.shipping?.destinatario?.localidad
  )
  const localidadId = localidadSeleccionada ? localidadSeleccionada.id : null
  return [
    {
      class: 'textfield',
      name: 'nombre',
      label: 'Razón social',
      value: data.shipping?.destinatario?.nombre,
      disabled: !edit,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChangeDest('nombre', e.target.value)
      },
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'telefono',
      label: 'Teléfono',
      value: data.shipping?.destinatario?.telefono,
      disabled: !edit,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChangeDest('telefono', e.target.value)
      },
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'cond_iva',
      label: 'Condición',
      optionValue: 'id',
      options: CONDICION,
      optionLabel: `options["label"]`,
      //value: condIvaLabel,
      value: data.shipping?.destinatario?.cond_iva,
      disabled: !edit,
      onChange: (e) => handleChangeDest('cond_iva', e.id),
    },
    {
      class: 'textfield',
      name: 'cuit',
      label: 'CUIT/CUIL/DNI',
      value: data.shipping?.destinatario?.cuit,
      sm: 6,
      xs: 12,
      disabled: !edit,
      onChange: (e) => {
        handleChangeDest('cuit', e.target.value)
      },
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'provincia',
      label: 'Provincia',
      optionValue: 'id',
      options: PROVINCIAS,
      optionLabel: `options["provincia"]`,
      value: provinciaId,
      disabled: !edit,
      onChange: (e) => handleChangeDest('provincia', e.provincia),
    },
    {
      class: 'autocomplete',
      sm: 6,
      xs: 12,
      name: 'localidad',
      label: 'Localidad',
      optionValue: 'id',
      options: localidadesFiltradas,
      optionLabel: `options["localidad"]`,
      value: localidadId,
      disabled: !edit,
      onChange: (e) => handleChangeDest('localidad', e.localidad),
    },
    {
      class: 'textfield',
      sm: 6,
      xs: 12,
      name: 'domicilio',
      label: 'Dirección',
      value: data.shipping?.destinatario?.domicilio,
      disabled: !edit,
      onChange: (e) => handleChangeDest('domicilio', e.target.value),
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'altura',
      label: 'Altura',
      value: data.shipping?.destinatario?.altura,
      disabled: !edit,
      sm: 3,
      xs: 12,
      onChange: (e) => {
        handleChangeDest('altura', e.target.value)
      },
    },
    {
      class: 'textfield',
      type: 'number',
      name: 'km',
      label: 'Km',
      value: data.shipping?.destinatario?.km,
      disabled: !edit,
      sm: 3,
      xs: 12,
      onChange: (e) => {
        handleChangeDest('km', e.target.value)
      },
    },
  ]
}
